function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.001 6.567c4.764 0 8.629 3.705 8.629 8.272 0 4.236-3.322 7.728-7.606 8.213v4.585h4.93V30H7.234v-5.908H6v-4.727c0-.65.555-1.182 1.233-1.182h3.698c.677 0 1.232.532 1.232 1.182v4.727h-1.232v3.545h8.628v-4.65c-4.08-.662-7.186-4.053-7.186-8.148 0-4.567 3.864-8.272 8.628-8.272zM9.063 13.636c.973 0 1.758.779 1.758 1.743 0 .965-.785 1.744-1.758 1.744a1.749 1.749 0 01-1.758-1.744c0-.964.785-1.743 1.758-1.743z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgTripTip = function SvgTripTip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTripTip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tripTip.4999588e.svg";
export { ForwardRef as ReactComponent };